import { render, staticRenderFns } from "./RequestAccount.vue?vue&type=template&id=7b666445&"
import script from "./RequestAccount.vue?vue&type=script&lang=js&"
export * from "./RequestAccount.vue?vue&type=script&lang=js&"
import style0 from "./RequestAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports